import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, resolveComponent as _resolveComponent } from "vue"

import { computed } from "vue";
import { ViewSchema } from "@/types";
import { DEFAULT_VIEW_NAME } from "@/util";
import {
  appStore,
  deltaStore,
  viewApiStore,
  documentSaveStore,
  documentStore,
  permissionStore,
} from "@/hooks";
import { IconButton, TextButton, ListItem, FlexBox } from "@/components/common";
import ViewHistory from "./ViewHistory.vue";


/**
 * A selector for switching between views.
 */
const __default__ = {
  name: "ViewSelector",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const options = computed(() => documentStore.projectDocuments);

const disabled = computed(() => deltaStore.inDeltaView);

/**
 * Returns whether a document can be saved.
 * @param doc - The document to check.
 * @return Whether saving is allowed.
 */
function canSave(doc = viewApiStore.currentDocument): boolean {
  return (
    doc.name !== DEFAULT_VIEW_NAME &&
    !doc.documentId &&
    permissionStore.isAllowed("project.edit_data")
  );
}

/**
 * Returns whether a document can be edited.
 * @param name - The document name, or none to check for general editing ability.
 * @return Whether editing is allowed.
 */
function canEdit(name = ""): boolean {
  return (
    name !== DEFAULT_VIEW_NAME && permissionStore.isAllowed("project.edit_data")
  );
}

/**
 * Opens the document creation panel.
 */
function handleCreateOpen(): void {
  documentSaveStore.baseDocument = undefined;
  appStore.openDetailsPanel("document");
}

/**
 * Opens the document edit panel.
 */
function handleEditOpen(document: ViewSchema): void {
  documentSaveStore.baseDocument = document;
  appStore.openDetailsPanel("document");
}

/**
 * Saves a new document.
 */
function handleSave(): void {
  viewApiStore.handleCreatePreset(viewApiStore.currentDocument);
}

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_select, {
    modelValue: _unref(viewApiStore).currentDocument,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(viewApiStore).currentDocument) = $event)),
    standout: "",
    "bg-color": "transparent",
    class: "nav-breadcrumb nav-view",
    "options-selected-class": "primary",
    options: options.value,
    disable: disabled.value,
    loading: _unref(viewApiStore).loading,
    label: "View",
    "option-label": "name",
    "option-value": "name",
    "data-cy": "button-document-select-open"
  }, {
    append: _withCtx(() => [
      _createVNode(_unref(FlexBox), {
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, {
        default: _withCtx(() => [
          _createVNode(ViewHistory),
          (canSave())
            ? (_openBlock(), _createBlock(_unref(IconButton), {
                key: 0,
                small: "",
                tooltip: "Save View",
                icon: "save",
                "data-cy": "button-document-select-save",
                onClick: handleSave
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    option: _withCtx(({
        opt,
        itemProps,
      }: {
        opt: ViewSchema;
        itemProps: Record<string, unknown>;
      }) => [
      _createVNode(_unref(ListItem), _mergeProps(itemProps, {
        title: opt.name,
        "action-cols": 2,
        "data-cy-name": opt.name
      }), {
        actions: _withCtx(() => [
          _createVNode(_unref(FlexBox), { justify: "end" }, {
            default: _withCtx(() => [
              (canSave(opt))
                ? (_openBlock(), _createBlock(_unref(IconButton), {
                    key: 0,
                    small: "",
                    tooltip: `Save ${opt.name}`,
                    icon: "save",
                    "data-cy": "button-document-select-save",
                    onClick: handleSave
                  }, null, 8, ["tooltip"]))
                : _createCommentVNode("", true),
              (canEdit(opt.name))
                ? _withDirectives((_openBlock(), _createBlock(_unref(IconButton), {
                    key: 1,
                    small: "",
                    icon: "edit",
                    tooltip: `Edit ${opt.name}`,
                    "data-cy": "button-document-select-edit",
                    onClick: ($event: any) => (handleEditOpen(opt))
                  }, null, 8, ["tooltip", "onClick"])), [
                    [_directive_close_popup]
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1040, ["title", "data-cy-name"])
    ]),
    "after-options": _withCtx(() => [
      (canEdit())
        ? _withDirectives((_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            text: "",
            block: "",
            label: "Add View",
            icon: "add",
            "data-cy": "button-document-select-create",
            onClick: handleCreateOpen
          }, null, 512)), [
            [_directive_close_popup]
          ])
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "options", "disable", "loading"]))
}
}

})